module.exports = __webpack_public_path__ + "img/agrartech_palyazat_inzert_aktiv.210932c6.png";